import { HttpHeaders } from '@angular/common/http';


export const defaultHeaders = {
  allHeader: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': '*/*',
  }),
  jsonHeader: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'text/json',
  }),

  pdfHeader: new HttpHeaders({
    'Content-Type': 'application/pdf',
    'Accept': '*/*',
  }),
  xmlHeader: new HttpHeaders({
    'Content-Type': 'application/xml',
    'Accept': 'text/XML',
  }),
  textHeader: new HttpHeaders({
    'Content-Type': 'application/text',
    'Accept': 'text/plain',
  }),
  fileUploadHeader: new HttpHeaders({
    'Accept': '*/*',
  }),
  fileDownloadHeader: new HttpHeaders({
    'Accept': '*/*',
  })
}



export function getRedactedEmail(email = '') {
  const emailArr = email.split('@');

  const firstHalf = emailArr?.[0] || '';
  const secondHalf = emailArr?.[1] || '';

  const newEmail = (firstHalf.split('').map((str, idx) => {
    return ((idx === 0) ||  (idx === (firstHalf.length - 1))) ? str : '*'
  })).join('');

  return `${newEmail}@${secondHalf}`;
}
